import React, { useEffect, useState } from 'react';
import { Button, Dropdown, Form, Header, Icon, Loader, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow } from 'semantic-ui-react';
import agent from '../../../app/api/agent';
import { colorizationMonthlyProductivityReport, ProductivityReportbyTitleBreakUp } from '../../../app/models/Restoration';
import { toast } from 'react-toastify';

interface DropdownItemProps {
  text: string;
  value: string;
}

const ColorizationMonthlyProductivityReport = () => {
  const [reportData, setReportData] = useState<colorizationMonthlyProductivityReport[]>([]);
  const [selectedMonth, setSelectedMonth] = useState<string>('');
  const [selectedYear, setSelectedYear] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [yearOptions1,setYearOption]=useState<DropdownItemProps[]>([]);
  const [showDetailsReport,setShowDetailsReport]=useState<boolean>(false);
   const [loadProjectData, setLoadProjectData] = useState<ProductivityReportbyTitleBreakUp[]>([]);
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const monthOptions: DropdownItemProps[] = months.map(month => ({
    text: month,
    value: month
  }));

  // const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() + i);
  // const yearOptions: DropdownItemProps[] = years.map(year => ({
  //   text: year.toString(),
  //   value: year.toString()
  // }));

  const handleMonthChange = (event: React.SyntheticEvent<HTMLElement>, data: any) => {
    setSelectedMonth(data.value);
  };

  const handleYearChange = (event: React.SyntheticEvent<HTMLElement>, data: any) => {
    setSelectedYear(data.value);
  };

  const handleViewReport = async () => {
    setLoading(true);
   
    if(!selectedYear){ toast.error('Please select a year.');  return;}
    if(!selectedMonth){ toast.error('Please select a Month.');  return;}
    try {
          if(showDetailsReport)
            {
              const response = await agent.ColorRestoration.colorizationMonthlyProductivityReportDateWiseByTitle(selectedMonth, selectedYear);
              setLoadProjectData(response.data);
            }
            else
            {
              const response = await agent.ColorRestoration.colorizationMonthlyProductivityReportDateWise(selectedMonth, selectedYear);
              setReportData(response.data);
            }
    } catch (error) {
      toast.error('Error fetching report data');
    } finally {
      setLoading(false);
    }
  };
  const YearOption=async ()=>{
    const responseYear=await agent.ColorRestoration.ColorizationYearsUpdate();
    setYearOption(responseYear.data);
  };
  const handleDownloadReport = () => {
    let csvContent = "data:text/csv;charset=utf-8,";
    if(selectedMonth && selectedYear && showDetailsReport) 
      {
        const headers = [
          "Employee ID", "Employee Name", "Project Name", 
          "Approval Frames", "Total Hours", "Date Of Floor", 
          "Current", "Tenure","Efficency",
           "Estimate Hour", "Total Frames","Target", 
           "Actual Target", "Productivity Percentage","Rejected Frames", 
           "Quality Percentage", "Artifacts Frames", "Artifacts Percentage"
        ];
        csvContent += headers.join(",") + "\r\n";
  
        loadProjectData.forEach(data => {
          const row = [
            data.employee_Id, data.employee_Name, data.project_Name, 
            data.approval_Frames,data.total_Hours,data.dof, 
            data.current,data.tenure, data.efficency, 
            data.est_Hour,data.total_Framess, data.target, 
            data.actualTarget,data.productivity_percentage, data.sum_of_Rejected_Frames,
            data.quality_percentage, data.artifacts_Rejected_Frames, data.artifacts_Rejection_percentage,
          ];
          csvContent += row.join(",") + "\r\n";
        });
      }
    if (selectedMonth && selectedYear && !showDetailsReport) {
      const headers = [
        "Employee ID", "Employee Name", "Designation", "Team", "Cluster Lead",
        "Sum of Frames", "Sum of Act Target", "Sum of Rejected Frames",
        "Artifacts Rejected Frames", "Productivity", "Quality Percentage",
        "Artifacts Rejected Frames Percentage", "Working Days", "Present Days",
        "Leaves", "Attendance Percentage", "Tenure", "Months", "Efficiency",
        "Attendance Hours", "HC Hours", "HC Adherence", "Scorecard", "Rank", "Points"
      ];
      csvContent += headers.join(",") + "\r\n";

      reportData.forEach(data => {
        const row = [
          data.emp_ID, data.emp_Name, data.designation, data.team, data.cluster_Lead,
          data.sum_of_Frames, data.sum_of_Act_Target, data.sum_of_Reject_Frame,
          data.artifacts_Rejected_Frames, data.productivity, data.quality_Percentage,
          data.artifacts_Rejected_Frames_Percentage, data.working_Days,
          data.present_Days, data.leaves, data.attendance_Percentage,
          data.tenure, data.months, data.efficency,
          data.attendance_Hours, data.hC_Hours, data.hC_Adherence,
          data.scorecard, data.rank, data.points
        ];
        csvContent += row.join(",") + "\r\n";
      });
    }

    const filename = () => {
      if (selectedMonth && selectedYear) {
        return `Monthly Productivity Report - ${selectedMonth}_${selectedYear}.csv`;
      }
      return '';
    };
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", filename());
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); 
  };

  useEffect(()=>{
    YearOption();
    // eslint-disable-next-line
  },[]);
  // const ReportbyTitleBreakUp=async()=>{
  //   try {
  //       await RestorationStore.ProductivityReportbyTitleBreakUpAPICall(month,year);
  //       setLoadProjectData(RestorationStore.ProductivityReportbyTitleBreakDetails)
  //       setLoading(false);
  //     }
  //   catch (error) {toast.error('Error fetching data');
  // }};
  return (
    <div className="title_wise_cutlistreport">
      <Header>Monthly Productivity Report - Colorization</Header>
      <div style={{ display: "flex", alignItems: 'center', marginBottom: '20px' }}>
        <div  style={{ marginRight: "10px" }}>
          <label style={{ fontWeight: "bold" }}>Year</label>
          <Dropdown
            clearable
            placeholder='Select a year'
            fluid
            selection
            options={yearOptions1}
            value={selectedYear}
            onChange={handleYearChange}
            style={{ width: "200px" }}
          />
        </div>
        <div  style={{ marginRight: "10px" }}>
          <label style={{ fontWeight: "bold" }}>Month</label>
          <Dropdown
            clearable
            placeholder='Select a month'
            fluid
            selection
            options={monthOptions}
            value={selectedMonth}
            onChange={handleMonthChange}
            style={{ width: "200px" }}
          />
        </div>
        {selectedMonth && selectedYear && (
          <>
          <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
              <Form.Field>
                    <div className="ui checked checkbox" >
                    <input type="checkbox" onClick={()=>setShowDetailsReport(!showDetailsReport)} checked={showDetailsReport}/>
                    <label>Show Project Wise Details</label>
                    </div> 
              </Form.Field>
            </div>
          
          <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
              <Button onClick={handleViewReport} primary>View Report</Button>
              <Button onClick={handleDownloadReport} style={{width: '50px'}}><Icon name='download' /></Button>
          </div></>
        )}
      </div>
      {loading ? (
        <Loader active inline='centered' />
      ) : (
        <div>
          {selectedMonth && selectedYear && !showDetailsReport ? (
            <div style={{ overflowY: 'auto', border: '1px solid #ccc', borderRadius: '5px', padding: '10px'}}>
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Employee ID</Table.HeaderCell>
                    <Table.HeaderCell>Employee Name</Table.HeaderCell>
                    <Table.HeaderCell>Designation</Table.HeaderCell>
                    <Table.HeaderCell>Team</Table.HeaderCell>
                    <Table.HeaderCell>Cluster Lead</Table.HeaderCell>
                    <Table.HeaderCell>Sum of Frames</Table.HeaderCell>
                    <Table.HeaderCell>Sum of Act Target</Table.HeaderCell>
                    <Table.HeaderCell>Sum of Rejected Frames</Table.HeaderCell>
                    <Table.HeaderCell>Artifacts Rejected Frames</Table.HeaderCell>
                    <Table.HeaderCell>Productivity</Table.HeaderCell>
                    <Table.HeaderCell>Quality Percentage</Table.HeaderCell>
                    <Table.HeaderCell>Artifacts Rejected Frames Percentage</Table.HeaderCell>
                    <Table.HeaderCell>Working Days</Table.HeaderCell>
                    <Table.HeaderCell>Present Days</Table.HeaderCell>
                    <Table.HeaderCell>Leaves</Table.HeaderCell>
                    <Table.HeaderCell>Attendance Percentage</Table.HeaderCell>
                    <Table.HeaderCell>Tenure</Table.HeaderCell>
                    <Table.HeaderCell>Months</Table.HeaderCell>
                    <Table.HeaderCell>Efficiency</Table.HeaderCell>
                    <Table.HeaderCell>Attendance Hours</Table.HeaderCell>
                    <Table.HeaderCell>HC Hours</Table.HeaderCell>
                    <Table.HeaderCell>HC Adherence</Table.HeaderCell>
                    <Table.HeaderCell>Scorecard</Table.HeaderCell>
                    <Table.HeaderCell>Rank</Table.HeaderCell>
                    <Table.HeaderCell>Points</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {reportData.length === 0 && (
                    <Table.Row>
                      <Table.Cell colSpan={15} textAlign="center">
                        No data available.
                      </Table.Cell>
                    </Table.Row>
                  )}
                  {reportData.length > 0 && reportData.map((data, index) => (
                    <Table.Row key={index}>
                      <Table.Cell>{data.emp_ID}</Table.Cell>
                      <Table.Cell>{data.emp_Name}</Table.Cell>
                      <Table.Cell>{data.designation}</Table.Cell>
                      <Table.Cell>{data.team}</Table.Cell>
                      <Table.Cell>{data.cluster_Lead}</Table.Cell>
                      <Table.Cell>{data.sum_of_Frames}</Table.Cell>
                      <Table.Cell>{data.sum_of_Act_Target}</Table.Cell>
                      <Table.Cell>{data.sum_of_Reject_Frame}</Table.Cell>
                      <Table.Cell>{data.artifacts_Rejected_Frames}</Table.Cell>
                      <Table.Cell>{data.productivity}</Table.Cell>
                      <Table.Cell>{data.quality_Percentage}</Table.Cell>
                      <Table.Cell>{data.artifacts_Rejected_Frames_Percentage}</Table.Cell>
                      <Table.Cell>{data.working_Days}</Table.Cell>
                      <Table.Cell>{data.present_Days}</Table.Cell>
                      <Table.Cell>{data.leaves}</Table.Cell>
                      <Table.Cell>{data.attendance_Percentage}</Table.Cell>
                      <Table.Cell>{data.tenure}</Table.Cell>
                      <Table.Cell>{data.months}</Table.Cell>
                      <Table.Cell>{data.efficency}</Table.Cell>
                      <Table.Cell>{data.attendance_Hours}</Table.Cell>
                      <Table.Cell>{data.hC_Hours}</Table.Cell>
                      <Table.Cell>{data.hC_Adherence}</Table.Cell>
                      <Table.Cell>{data.scorecard}</Table.Cell>
                      <Table.Cell>{data.rank}</Table.Cell>
                      <Table.Cell>{data.points}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          ):(
<div>
  <Table>
    <TableHeader>
      <TableRow>
        <TableHeaderCell>Employee Id</TableHeaderCell>
        <TableHeaderCell>Employee Name</TableHeaderCell>
        <TableHeaderCell>Project Name</TableHeaderCell>
        <TableHeaderCell>Approval Frames</TableHeaderCell>
        <TableHeaderCell>Total Hours</TableHeaderCell>
        <TableHeaderCell>Date Of Floor</TableHeaderCell>
        <TableHeaderCell>Current</TableHeaderCell>
        <TableHeaderCell>Tenure</TableHeaderCell>
        <TableHeaderCell>Efficency</TableHeaderCell>
        <TableHeaderCell>Estimate Hour</TableHeaderCell>
        <TableHeaderCell>Total Frames</TableHeaderCell>
        <TableHeaderCell>Target</TableHeaderCell>
        <TableHeaderCell>Actual Target</TableHeaderCell>
        <TableHeaderCell>Productivity %</TableHeaderCell>
        <TableHeaderCell>Rejected Frames</TableHeaderCell>
        <TableHeaderCell>Quality %</TableHeaderCell>
        <TableHeaderCell>Artifacts Frames</TableHeaderCell>
        <TableHeaderCell>Artifacts %</TableHeaderCell>
      </TableRow>
    </TableHeader>
    <TableBody>
    {loadProjectData.length === 0 &&  loading === false && (
                      <Table.Row>
                        <Table.Cell colSpan={18} textAlign="center">
                          Currently Data not Avaialabe
                        </Table.Cell>
                      </Table.Row>
    )}
    {
      loadProjectData.map((data, index) => (
      <TableRow key={index}>
        <TableCell>{data.employee_Id}</TableCell>
        <TableCell>{data.employee_Name}</TableCell>
        <TableCell>{data.project_Name}</TableCell>
        <TableCell>{data.approval_Frames}</TableCell>
        <TableCell>{data.total_Hours}</TableCell>
        <TableCell>{data.dof}</TableCell>
        <TableCell>{data.current}</TableCell>
        <TableCell>{data.tenure}</TableCell>
        <TableCell>{data.efficency}</TableCell>
        <TableCell>{data.est_Hour}</TableCell>
        <TableCell>{data.total_Framess}</TableCell>
        <TableCell>{data.target}</TableCell>
        <TableCell>{data.actualTarget}</TableCell>
        <TableCell>{data.productivity_percentage}</TableCell>
        <TableCell>{data.sum_of_Rejected_Frames}</TableCell>
        <TableCell>{data.quality_percentage}</TableCell>
        <TableCell>{data.artifacts_Rejected_Frames}</TableCell>
        <TableCell>{data.artifacts_Rejection_percentage}</TableCell>
      </TableRow>
    ))}
    </TableBody>
  </Table>

</div>

          )}
        </div>
      )}
    </div>
  );
};

export default ColorizationMonthlyProductivityReport;
